import { render, staticRenderFns } from "./notificar_cotizaciones_dialog.vue?vue&type=template&id=1d4c48cc&lang=pug&"
import script from "./notificar_cotizaciones_dialog.vue?vue&type=script&lang=js&"
export * from "./notificar_cotizaciones_dialog.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports